import {
  UpdateBankInput,
  UpdateStripePendingInput,
} from "@/domain/dtos/inputs";
import { CreditCard } from "@/domain/entities";
import { GenericError } from "@/domain/errors";
import { PaymentMapper } from "@/domain/mappers";
import { PaymentRepository } from "@/domain/repositories";
import { PaymentDataSource } from "../datasources/payment";
import { CreditCardResponse } from "../dtos/responses";

export class PaymentRepoImpl implements PaymentRepository {
  constructor(
    private readonly dataSource: PaymentDataSource,
    private readonly paymentMapper: PaymentMapper<CreditCardResponse>,
  ) {}

  async getCreditCards() {
    const data = await this.dataSource.getCreditCards();
    return data.map((elem) => this.paymentMapper.toCreditCardDomain(elem));
  }

  async getFavoriteCard(
    cards: CreditCard[],
    currentCardId?: string,
  ): Promise<CreditCard | null> {
    const favorite_card = cards.find(
      (card: CreditCard) => card.card_id === currentCardId,
    );
    return favorite_card || cards[0];
  }

  createCreditCard(card_hash: string) {
    return this.dataSource.createCreditCard(card_hash);
  }

  deleteCard(card_id: string) {
    return this.dataSource.deleteCard(card_id);
  }

  getStripeAccountLink(
    id: number | string | undefined,
  ): Promise<{ url: string }> {
    if (!id) throw new GenericError();
    return this.dataSource.getStripeAccountLink(id);
  }

  updateStripePending(params: UpdateStripePendingInput): Promise<unknown> {
    return this.dataSource.updateStripePending(params);
  }

  async paymentRetry(
    appointmentId: number,
    cardId: string,
  ): Promise<{ client_secret: string | undefined }> {
    const data = await this.dataSource.paymentRetry(appointmentId, cardId);

    return {
      client_secret: data?.client_secret,
    };
  }

  getBankCodes(): Promise<any[]> {
    return this.dataSource.getBanks();
  }

  updateBank(params: UpdateBankInput): Promise<unknown> {
    return this.dataSource.updateBank(params);
  }
}
